<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-locale-provider>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  mounted() {
    if (this.$store.state.region === 1) {
      document.title = "山西省职业教育铸魂育人计划项目监测与管理平台";
    } else if (this.$store.state.region === 2) {
      document.title = "临汾市职业院校铸魂育人计划项目遴选";
    } else if (this.$store.state.region === 3) {
      document.title = "长治市职业院校铸魂育人计划项目遴选";
    } else if (this.$store.state.region === 5) {
      document.title = "山西省职业院校铸魂育人计划项目遴选";
    } else {
      document.title = "山西省职业教育铸魂育人计划项目监测与管理平台";
    }
  },
};
</script>
<style lang="scss">
@import "./assets/style/base.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-white;
}
.ant-table-align-center {
  // background:#BFD6FF !important;
  font-size: 16px !important;
  font-weight: 600;
  color: #fff !important;
  background-color: #426DD3!important;
  border-right: 1px solid #426DD3 !important;
  // border-right: 1px solid #2469E7 !important;
}
.ant-table-thead>tr>th{
   background-color: #426DD3!important;
   border-right: 1px solid #426DD3 !important;
}
.ant-table-align-center:last-child {
  border-right: 1px solid #426DD3 !important;
}
/* 选择表格的奇数行 */
.ant-table-tbody tr:nth-child(odd) {
   /* 奇数行的背景颜色 */
   background-color: #ffffff;
}

/* 选择表格的偶数行 */
.ant-table-tbody tr:nth-child(even) {
   /* 偶数行的背景颜色 */
  background-color: #F4F6FA;
}
.ant-tree {
  color: #2155B5 !important;
}
.ant-tree li .ant-tree-node-content-wrapper {
  font-size: 16px !important;
  font-family: Microsoft YaHei !important;
  font-weight: bold !important;
  color: #2155B5 !important;
}
.ant-tree li ul li .ant-tree-node-content-wrapper {
  font-size: 16px !important;
  font-family: Microsoft YaHei !important;
  font-weight: 400 !important;
  color: #3c3c3c !important;
}
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  background: none !important;
}

.ant-card-body {
  padding: 20px 0px !important;
}
.ant-upload-list-item {
  width: 500px !important;
}
.ant-upload-list-item-info i,
.ant-upload-list-item-info span {
  color:#2155B5 !important;
}
.ant-tree-treenode-switcher-close {
  overflow: hidden !important;
}
.ant-tree-treenode-switcher-open {
  overflow: hidden !important;
}
.ant-tree-node-content-wrapper {
  flex: 1;
}
.ant-btn-primary {
  background-color: #2155B5 !important;
  border: none !important;
}
</style>
